import { lazy } from "preact-iso";

const Button = lazy(() => import("@mui/material/Button"));

export default function SmallButton({
  children,
  ...buttonProps
}: Parameters<typeof Button>[0] & { target?: string }) {
  return (
    <Button
      style={{
        padding: "inherit",
        minWidth: "auto",
        fontSize: "inherit",
        "--variant-textColor": "initial",
      }}
      {...buttonProps}
    >
      {children}
    </Button>
  );
}
